'use strict'

import submitForm from './submitForm'

export default function (): void {
  const form = document.getElementById('reviews_sort_sort') as HTMLFormElement

  if (form) {
    form.addEventListener('change', function () {
      submitForm(document.querySelector('form[name=reviews_sort') as HTMLFormElement)
    })
  }
}
